import apis from './../const/apis';
import { IFeelgoodConfig } from '@byted-feelgood/deliverer/dist/types/types';
import Feelgood from '@byted-feelgood/deliverer';
import * as tool from './../utils/tool';
import request from './../utils/request/index';
import { has } from 'lodash';
import { computed, ref } from 'vue-demi';
const FeelGoodPlugin: any = {};
const { aadvid } = tool.queryToJson();
const hasAd = ref(false);

async function feelgoodTriggerEvent() {
  try {
    const { data } = await request.get(apis.account.creationStatistics);
    const { active, spending, not_delivery } = data.campaigns;
    return Number(active + spending + not_delivery) > 0;
  } catch (e) {
    console.log('Error in feelgood: ', e);
    return false;
  }
}

FeelGoodPlugin.install = async () => {
  if (FeelGoodPlugin.installed) {
    return;
  }
  // initialize SDK
  try {
    //start feelgood
    //construction
    hasAd.value = await feelgoodTriggerEvent();

    //initialization
    const params: IFeelgoodConfig = {
      platformID: '7187694435793403906', // platform id
      // host domain should be the same as the domain to get token
      host: 'web-sg.tiktok.com',
      getAuthToken: async () =>
        // backend api to get feelgood token
        fetch(apis.feelgoodtoken, {
          method: 'GET',
        })
          .then((response) => response.json())
          .then((res) => {
            return res.data;
          }),
      language: 'en', //language used for survey
      sign: {
        // custom label, used to match the survey. e.g. user_id
        advId: aadvid,
        has_ad_delivery: hasAd.value ? 'yes' : 'no',
      },
    };

    const feelgood = new Feelgood(params);
  } catch (error) {
    console.log('Error caught in feelgood plugin installation', error);
  }
  FeelGoodPlugin.installed = true;
};

export default FeelGoodPlugin;
